import React from 'react';
export function Footer() {
  return <footer className="bg-blue-900 text-white py-12" data-id="element-85">
      <div className="max-w-7xl mx-auto px-4" data-id="element-86">
        <div className="grid md:grid-cols-4 gap-8 mb-8" data-id="element-87">
          <div data-id="element-88">
            <h3 className="font-bold text-lg mb-4" data-id="element-89">Mar</h3>
            <ul className="space-y-2 text-sm" data-id="element-90">
              <li data-id="element-91">
                <a href="#" className="hover:underline" data-id="element-92">
                  Sobre
                </a>
              </li>
              <li data-id="element-93">
                <a href="#" className="hover:underline" data-id="element-94">
                  Missão
                </a>
              </li>
              <li data-id="element-95">
                <a href="#" className="hover:underline" data-id="element-96">
                  Visão
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-97">
            <h3 className="font-bold text-lg mb-4" data-id="element-98">Links Úteis</h3>
            <ul className="space-y-2 text-sm" data-id="element-99">
              <li data-id="element-100">
                <a href="#" className="hover:underline" data-id="element-101">
                  Legislação
                </a>
              </li>
              <li data-id="element-102">
                <a href="#" className="hover:underline" data-id="element-103">
                  Publicações
                </a>
              </li>
              <li data-id="element-104">
                <a href="#" className="hover:underline" data-id="element-105">
                  Dados Abertos
                </a>
              </li>
              <li data-id="element-106">
                <a href="#" className="hover:underline" data-id="element-107">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-108">
            <h3 className="font-bold text-lg mb-4" data-id="element-109">Contactos</h3>
            <ul className="space-y-2 text-sm" data-id="element-110">
              <li data-id="element-111">Email: info@mar.pt</li>
              <li data-id="element-112">Tel: +351 21 000 0000</li>
              <li data-id="element-113">Morada: Lisboa, Portugal</li>
            </ul>
          </div>
          <div data-id="element-114">
            <h3 className="font-bold text-lg mb-4" data-id="element-115">Siga-nos</h3>
            <div className="flex gap-4" data-id="element-116">
              <a href="#" className="hover:text-blue-300" data-id="element-117">
                Facebook
              </a>
              <a href="#" className="hover:text-blue-300" data-id="element-118">
                Twitter
              </a>
              <a href="#" className="hover:text-blue-300" data-id="element-119">
                LinkedIn
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-blue-800 pt-8 text-sm text-center" data-id="element-120">
          <p data-id="element-121">© 2024 Plataforma do Mar. Todos os direitos reservados.</p>
          <div className="mt-4 flex justify-center gap-6" data-id="element-122">
            <a href="#" className="hover:underline" data-id="element-123">
              Política de Privacidade
            </a>
            <a href="#" className="hover:underline" data-id="element-124">
              Termos de Uso
            </a>
            <a href="#" className="hover:underline" data-id="element-125">
              Acessibilidade
            </a>
          </div>
        </div>
      </div>
    </footer>;
}